import * as Types from '../../../../../../../admin/graphql/src/lib/types';

import { InferenceStream } from '@wm-front/core'
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type FetchDeviceSpecsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type FetchDeviceSpecsQuery = { __typename?: 'Query', deviceSpecsFilterOptions: Array<{ __typename?: 'DeviceTypeSpecFilterOptions', deviceType: Types.DeviceType, specs: Array<{ __typename?: 'DeviceSpecFilterOption', key: string, title: string, options: Array<{ __typename?: 'DeviceSpecFilterOptionValue', label: string, value: string }> }> }> };

export const FetchDeviceSpecsDocument = gql`
    query FetchDeviceSpecs {
  deviceSpecsFilterOptions {
    deviceType
    specs {
      key
      title
      options {
        label
        value
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchDeviceSpecsGQL extends Apollo.Query<FetchDeviceSpecsQuery, FetchDeviceSpecsQueryVariables> {
    override document = FetchDeviceSpecsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }